import { GzImageRepoWebComponent } from './component/GzImageRepoWebComponent';
import { WEB_COMPONENT_GZ_IMAGE_REPO } from '../../webcomponents.constants';

export { GzImageRepoWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_IMAGE_REPO, GzImageRepoWebComponent);
